<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title> Anexos </mat-panel-title>
  </mat-expansion-panel-header>
  <!--<div *ngIf="mdr">-->
    <!--<app-attachments [mdr]="mdr">-->
    <!--</app-attachments>-->
  <!--</div>-->
</mat-expansion-panel>
